<template>
  <div>
    <div class="mb-3" v-for="[key, value] in Object.entries(secrets)">
      <span :class="{'h6': !editable}">{{ $t(`js.backend.voter_secrets.voter_attribute.${key}`) }}</span><br>
      <input v-if="editable && value !== null " class="form-control" type="text" v-model="secrets[key]" :name="`voter[${key}]`" :id="`voter_${key}`">
      <p class="text-muted" v-if="value && !editable">{{ value }}</p>
      <button v-if="value === null" type="button" @click.prevent="reveal(key)" class="btn btn-sm btn-secondary mt-1">
        <i class="fas fa-eye"></i>
        {{ $t('js.backend.voter_secrets.reveal') }}
      </button>
    </div>
  </div>
</template>

<script>
  import apiClient from "../../packs/frontend/apiClient"

  export default {
    name: "VoterSecrets",
    props: {
      voter_id: Number,
      secrets: {},
      editable: false
    },
    methods: {
      reveal(key){
        let url = this.editable ? "../"+this.voter_id+'/reveal' : this.voter_id+'/reveal'
        apiClient.get(url, {params: {secret: key}}).then(res => {
          if(res.status >= 200 && res.status < 300){
            this.secrets[key] = res.data[key]
          }
        })
      }
    }

  }
</script>